import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceHistoryComponent } from '../shared/service-history/service-history.component';
import { BDCDashboardComponent } from './bdc-dashboard.component';

const routes: Routes = [
  {
      path: '',
      component: BDCDashboardComponent,
  },
  {
      path: 'servicehistory',
      component: ServiceHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BDCDashboardRoutingModule { }
